import { ReturnCode } from 'app/modules/remote-control-ng/definitions';
import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';

/** PC_DEVICE2DESK_NOTIFICATION MessageType */
export class Device2DeskMessage extends BaseMessage {
    static readonly UserDeclineNotification = 1;
    public returnCode: ReturnCode;

    public deserializeBody(memoryBuffer: MemoryBuffer): void {
        var type = memoryBuffer.readInt32BE();
        if (type === Device2DeskMessage.UserDeclineNotification) {
            this.returnCode = ReturnCode.PCR_LOGIN_REJECTED;
        }
    }
}
